import {Age} from "../models/clinical-ranges/age";

export class PatientHelpers {
  public static calculateAge(birthDate: Date | string | number): Age {
    const age = new Age(0,0,0);

    if (!birthDate) return age;

    if (typeof birthDate === 'string' || typeof birthDate === 'number') {
      birthDate = new Date(birthDate);
    }

    const now = new Date();
    const dobYear = birthDate.getFullYear();
    const dobMonth = birthDate.getMonth();
    const dobDate = birthDate.getDate();

    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const currentDate = now.getDate();

    age.years = currentYear - dobYear;

    if (currentMonth >= dobMonth)
      age.months = currentMonth - dobMonth;
    else {
      age.years--;
      age.months = 12 + currentMonth - dobMonth;
    }

    if (currentDate >= dobDate)
      age.days = currentDate - dobDate;
    else {
      age.months--;
      age.days = 31 + currentDate - dobDate;

      if (age.months < 0) {
        age.months = 11;
        age.years--;
      }
    }

    return age;
  }
}

